"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../../../billing/Models");
class ResidentSearchDto {
}
exports.ResidentSearchDto = ResidentSearchDto;
